var map = {
	"./chinatown/assets/logo.png": "256d",
	"./dailypizza/assets/logo.png": "8fa9",
	"./diyars/assets/logo.png": "8d1b",
	"./enjoy-food/assets/logo.png": "54b9",
	"./mryu/assets/logo.png": "f517",
	"./napolimania/assets/logo.png": "b0ab",
	"./ni-hao-kaiser/assets/logo.png": "46fd",
	"./pizzeria-no3/assets/logo.png": "0fcb",
	"./testrestaurant/assets/logo.png": "8fdf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dd1e";